import { v4 as uuidv4 } from 'uuid';

import { FileUploadRequestModel } from '../../models/interfaces/file-upload-request.model';
import { FileUploadResponseModel } from '../../models/interfaces/file-upload-response.model';
import { FileUploadOptionsModel } from '../../models/interfaces/file-upload.model';

export class FileUploadHelper {
    private readonly STATUS = {
        SUCCESS: 'success' as const,
        FAILED: 'failed' as const
    };

    createFileMetadata(extension: string, options: FileUploadOptionsModel): FileUploadRequestModel {
        return {
            filename: `${uuidv4()}.${extension}`,
            public: options.public,
            category: options.category
        };
    }

    createSuccessResponse(responseBody: any): FileUploadResponseModel {
        const file = responseBody as FileUploadResponseModel;
        file.status = this.STATUS.SUCCESS;
        return file;
    }

    createFailedResponse(
        fileName: string,
        errorMessage: string,
        errorCode: string,
        isPublic: boolean = true
    ): FileUploadResponseModel {
        return {
            status: this.STATUS.FAILED,
            public: isPublic,
            errorMessage,
            code: errorCode,
            name: fileName
        } as FileUploadResponseModel;
    }

    hasPrivateFiles(files: FileUploadResponseModel[]): boolean {
        return files?.some((file) => !file.public) ?? false;
    }

    getFileSizeInMB(sizeInBytes: number): number {
        return Math.round(sizeInBytes / 1024 / 1024);
    }

    isSuccessStatus(status: string): boolean {
        return status === this.STATUS.SUCCESS;
    }

    isFailedStatus(status: string): boolean {
        return status === this.STATUS.FAILED;
    }

    setFileSizeNoteIfCustom(options: FileUploadOptionsModel, defaultMaxSize: number): FileUploadOptionsModel {
        if (options.general?.restrictions?.maxFileSize !== defaultMaxSize) {
            const sizeInMB = this.getFileSizeInMB(options.general.restrictions.maxFileSize);
            options.dashboard.note = `Maximum allowed size ${sizeInMB} MB.`;
        }
        return options;
    }
}
